import { useEffect, useState } from 'react';

/**
 * The value, once it has stayed the same for `ms` milliseconds. "The same" is by identity: pass a primitive, or an
 * object memoized on a stable key (e.g. useMemo keyed by its JSON); a new object every render restarts the timer.
 */
export function useDebounced<T>(value: T, ms: number): T {
  const [v, setV] = useState(value);
  useEffect(() => {
    const t = setTimeout(() => setV(value), ms);
    return () => clearTimeout(t);
  }, [value, ms]);
  return v;
}
